import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SubSystemType } from '../../library/models/data.models';
import { ApiService } from '../../library/services/api.service';
import { ConnectionService } from '../../shared/services/connection.service';

@Injectable()
export class SubSystemApiService extends ApiService {

    constructor(protected http: HttpClient, protected connectionService: ConnectionService) {
        super(http, connectionService);
    }

    public get(id: number): Observable<SubSystemType[]> {
        return this.httpGET(this.apiUrl + '/sub-system', this.getOptions({ subSystem: id }));
    }

    public add(data): Observable<any> {
        return this.httpPOST(this.apiUrl + '/sub-system/add', data, this.getOptions());
    }
}
